// extracted by mini-css-extract-plugin
export var active = "_d4-c";
export var compactArrow = "_d4-5";
export var container = "_d4-0";
export var dot = "_d4-b";
export var dotContainer = "_d4-a";
export var hoverArrowButton = "_d4-7";
export var hoverArrowContainer = "_d4-6";
export var leftHoverArrowContainer = "_d4-8 _d4-6";
export var rightHoverArrowContainer = "_d4-9 _d4-6";
export var slide = "_d4-4";
export var sliderContainer = "_d4-1";
export var sliderContainerVisibleOverflow = "_d4-2";
export var sliderOverflow = "_d4-3";
export var vignetteBoth = "_d4-f";
export var vignetteLeft = "_d4-e";
export var vignetteRight = "_d4-d";